<template>
  <div class="topic-manager">
    <div class="row" style="margin-bottom: 20px;">
      <div class="col-xl-6">初审员</div>
      <div class="col-xl-6" style="display: flex;justify-content: flex-end;align-items: center;">
        <Breadcrumb></Breadcrumb>
      </div>
    </div>

    <el-card>
      <template v-if="status==1">
        <div class="mb-2">
          <span>区域名称：</span>
          <el-input v-model="query.name" placeholder="请输入区域名称" class="ml-3 mr-3" style="width: 180px" size="small" clearable></el-input>
          <el-button type="info" size="small" @click="getData">查询</el-button>
        </div>
        <el-table :header-cell-style="tableHeaderStyle" :data="list" border style="width: 100%">
          <el-table-column key="1" prop="regionName" label="区域名称" min-width="180"></el-table-column>
          <el-table-column key="2" prop="realNames" label="初审员姓名" min-width="180">
            <template slot-scope="scope">
              <span v-for="item in scope.row.roleUserVos" :key="item.id">
                {{item.name}}
                <template v-if="item.learningSection && item.learningSection.length>0">
                  ({{item.learningSection | stageTextFilters}})&nbsp;
                </template>
              </span>
            </template>
          </el-table-column>
          <el-table-column key="3" label="操作" min-width="180">
            <template slot-scope="scope">
              <el-button type="info" size="small" @click="toUpdate(scope.row,'man')">指定初审员</el-button>
              <el-button size="small" @click="toUpdate(scope.row,'stage')">设置初审学段</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页器 -->
        <div class="text-right mt-2">
          <el-pagination background layout="total, prev, pager, next" :page-size="query.pageSize" :total="total" @current-change="(e)=>{handlePageChange(e,'1')}"></el-pagination>
        </div>
      </template>
      <template v-if="status==2">
        <el-page-header @back="getData" content="设置初审员" class="mb-2"></el-page-header>
        <div class="mb-2">
          <span>姓名：</span>
          <el-input v-model="queryUser.realName" placeholder="请输入" class="ml-3 mr-3" style="width: 180px" size="small"></el-input>
          <span>单位：</span>
          <el-input v-model="queryUser.unitName" placeholder="请输入" class="ml-3 mr-3" style="width: 180px" size="small"></el-input>
          <el-button type="success" size="small" @click="getUserList">查询</el-button>
        </div>
        <el-table :header-cell-style="tableHeaderStyle" :data="userList" border style="width: 100%">
          <el-table-column key="5" prop="realName" label="姓名" min-width="180"></el-table-column>
          <el-table-column key="6" prop="unitName" label="单位" min-width="180"></el-table-column>
          <el-table-column key="7" prop="username" label="用户名" min-width="180"></el-table-column>
          <el-table-column key="8" label="操作" min-width="180">
            <template slot-scope="scope">
              <el-button v-if="scope.row.roleId.indexOf('2')==-1" type="success" size="small" @click="changeRole(scope.row)">设为初审员</el-button>
              <el-button v-else type="danger" size="small" @click="changeRole(scope.row)">取消初审员</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页器 -->
        <div class="text-right mt-2">
          <el-pagination background layout="total, prev, pager, next" :page-size="queryUser.pageSize" :total="userTotal" @current-change="(e)=>{handlePageChange(e,'user')}"></el-pagination>
        </div>
      </template>
      <template v-if="status==3">
        <el-page-header @back="getData" content="设置初审员审核范围" class="mb-2"></el-page-header>
        <el-table :header-cell-style="tableHeaderStyle" :data="stageList" border style="width: 100%">
          <el-table-column key="39" prop="name" label="姓名" min-width="180"></el-table-column>
          <el-table-column key="310" prop="unitName" label="单位" min-width="180"></el-table-column>
          <el-table-column key="315" prop="unitName" label="学段" min-width="180">
            <template slot-scope="scope">
              <span v-if="scope.row.learningSection && scope.row.learningSection.length>0">{{scope.row.learningSection | stageTextFilters}}</span>
              <span v-else>暂无</span>
            </template>
          </el-table-column>
          <el-table-column key="311" label="操作" min-width="120">
            <template slot-scope="scope">
              <el-button size="small" type="primary" @click="handleStageChange(scope.row,scope.$index)">设置学段</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </el-card>
    <!-- 设置学段对话框 -->
    <el-dialog title="设置初审员审核学段" :visible.sync="setAuditScopeDialogVisible" width="30%" :close-on-click-modal="false">
      <div class="audit-scope">
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="stageSelectAllChange">全选</el-checkbox>
        <div style="margin: 15px 0;"></div>
        <el-checkbox-group v-model="stageUserData.learningSection">
          <el-checkbox v-for="item in stageOptions" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setAuditScopeDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="stageSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from "@/views/backstage/components/Breadcrumb.vue";
import {
  getExaminerVoList,
  getUserList,
  updateRole,
  updateLearningSection,
} from "@/api/after/systemManagement";
export default {
  components: {
    Breadcrumb,
  },
  data() {
    return {
      tableHeaderStyle: {
        backgroundColor: "#3083c5",
        color: "#fff",
      },
      status: 1,
      query: {
        name: "",
        pageNumber: 1,
        pageSize: 10,
        pageSorts: [{ asc: true, column: "" }],
      },
      list: [],
      total: 0,
      queryUser: {
        realName: "",
        region: "",
        unitName: "",
        pageNumber: 1,
        pageSize: 10,
        pageSorts: [{ asc: true, column: "" }],
      },
      userList: [],
      userTotal: 0,

      // status==3
      setAuditScopeDialogVisible: false,
      stageList: [],
      stageOptions: [
        { id: "0", name: "幼儿园" },
        { id: "1", name: "小学" },
        { id: "2", name: "初中" },
        { id: "3", name: "高中" },
        { id: "4", name: "中/高职" },
        { id: "5", name: "其他" },
      ],
      stageUserData: {}, //学段-正在被编辑的用户
      stageUserIndex: null, //学段-正在被编辑的用户列表第几项
      checkAll: false, //是否全选
      isIndeterminate: false, //全选按钮状态
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // 获取数据列表
    getData() {
      getExaminerVoList(this.query).then((res) => {
        if (res.code == 200) {
          this.status = 1;
          this.list = res.data.records;
          this.total = res.data.total;
        } else {
          this.$message.error(res.data);
        }
      });
    },
    toUpdate(data, name) {
      if (name == "man") {
        this.queryUser.region = data.regionId;
        this.getUserList();
      } else if (name == "stage") {
        if (data.roleUserVos && data.roleUserVos.length > 0) {
          this.stageList = data.roleUserVos;
          this.status = 3;
        }
      }
    },
    // status===2--------------------------------
    getUserList() {
      getUserList(this.queryUser).then((res) => {
        if (res.code == 200) {
          this.userList = res.data.records;
          this.userTotal = res.data.total;
          this.status = 2;
        } else {
          this.$message.error(res.data);
        }
      });
    },
    handleSelectionChange(val) {
      console.log(val);
    },
    changeRole(data) {
      let arr = data.roleId ? data.roleId.split(",") : [];
      console.log(arr);
      if (arr.indexOf("2") !== -1) {
        arr.splice(arr.indexOf("2"), 1);
      } else {
        arr.push("2");
      }
      arr = arr.join(",");
      let query1 = [{ id: data.id, roleId: arr }];
      console.log(query1);
      this.updateUser(query1);
    },
    updateUser(query) {
      updateRole(query).then((res) => {
        if (res.code == 200) {
          this.$message.success("修改成功");

          this.getUserList();
        } else {
          this.$message.error(res.data);
        }
      });
    },
    // status===3--------------------------------
    // 设置学段
    handleStageChange(data, index) {
      this.stageUserData = JSON.parse(JSON.stringify(data));
      this.stageUserIndex = index;
      this.stageUserData.learningSection = this.stageUserData.learningSection
        ? this.stageUserData.learningSection
        : [];
      this.stageUserData.learningSection.length > 0
        ? (this.isIndeterminate = true)
        : (this.isIndeterminate = false);
      this.setAuditScopeDialogVisible = true;
    },
    stageSelectAllChange(val) {
      let arr = ["0", "1", "2", "3", "4", "5"];
      this.stageUserData.learningSection = val ? arr : [];
      this.isIndeterminate = false;
    },
    stageSubmit() {
      let query = {
        roleId: "2",
        id: this.stageUserData.id,
        eduLearningSection: this.stageUserData.learningSection.join(","),
      };
      this.updateLearningSection(query);
    },
    // 修改学段
    updateLearningSection(query) {
      updateLearningSection(query).then((res) => {
        if (res.code == 200) {
          this.$message.success("修改成功");
          if (this.status == 3) {
            this.stageList[
              this.stageUserIndex
            ].learningSection = this.stageUserData.learningSection;
          }
        } else {
          this.$message.error(res.data);
        }
        this.setAuditScopeDialogVisible = false;
      });
    },
    // 分页导航
    handlePageChange(val, name) {
      if (name == "1") {
        this.query.pageNumber = val;
        this.getData();
      } else {
        this.queryUser.pageNumber = val;
        this.getUserList();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.btn-wrap {
  margin-top: 20px;
}
</style>
